/**
 * Admin V3 — French label dictionary (primary)
 *
 * Phase 1 scope: navigation labels, top-bar, placeholder copy.
 * Per-module labels (bookings.*, drivers.*, etc.) will be added in their
 * respective module phases.
 */

const fr = {
  // Top bar
  'admin.title':                'BLACK MATTE',
  'admin.subtitle':             'Administration',
  'admin.user.role':            'Administrateur',
  'admin.button.logout':        'Déconnexion',

  // Sidebar group labels
  'nav.group.operations':       'Opérations',
  'nav.group.financial':        'Financier',
  'nav.group.configuration':    'Configuration',

  // Main module labels
  'nav.overview':               'Tableau de bord',
  'nav.bookings':               'Réservations',
  'nav.drivers':                'Chauffeurs',
  'nav.onboarding':             'Onboarding',
  'nav.operations':             'Opérations',
  'nav.incidents':              'Incidents',
  'nav.billing':                'Facturation',
  'nav.partners':               'Partenaires',
  'nav.corporate':              'Entreprises',
  'nav.financial':              'Trésorerie',
  'nav.commissions':            'Commissions',
  'nav.subscriptions':          'Abonnements',
  'nav.pricing':                'Tarification',
  'nav.messages':               'Messages',
  'nav.contacts':               'Messages',
  'nav.settings':               'Paramètres',

  // Sidebar sub-item labels
  'nav.operations.live':            'Live',
  'nav.operations.audit':           'Audit',
  'nav.operations.notifications':   'Notifications',
  'nav.operations.health':          'Santé système',
  'nav.billing.invoices':           'Factures',
  'nav.billing.avoirs':             'Avoirs',
  'nav.billing.devis':              'Devis',
  'nav.billing.commande':           'Bons de commande',
  'nav.billing.cycle':              'Cycles',
  'nav.billing.vat':                'TVA',
  'nav.partners.pricingProfiles':   'Profils tarifaires',
  'nav.financial.payouts':          'Versements chauffeurs',
  'nav.financial.withdrawals':      'Retraits',
  'nav.financial.ledger':           'Grand livre',
  'nav.bookings.list':              'Toutes les réservations',
  'nav.bookings.unassigned':        'À assigner',

  // Module placeholder copy
  'placeholder.module.title':   'Module en préparation',
  'placeholder.module.desc':    "Ce module sera ajouté progressivement. En attendant, utilisez /admin pour cette fonctionnalité.",
  'placeholder.notFound.title': 'Page introuvable',
  'placeholder.notFound.desc':  'Cette URL ne correspond à aucun module de l\'administration.',

  // Detail-page placeholder (with route param)
  'placeholder.detail.title':   '{module}: {id}',
  'placeholder.detail.desc':    "Page de détail en préparation. L'identifiant de l'URL est correctement reçu.",

  // Phase 2.1 — Overview module
  'overview.kpi.revenueToday':         "Chiffre d'affaires aujourd'hui",
  'overview.kpi.bookingsToday':        "Réservations aujourd'hui",
  'overview.kpi.driversOnline':        'Chauffeurs en ligne',
  'overview.kpi.pendingRequests':      'Demandes en attente',

  // Commercial backlog card (F2)
  'overview.backlog.title':            'À traiter — commercial',
  'overview.backlog.acceptedDevis':    'Devis acceptés',
  'overview.backlog.draftBdc':         'Bons de commande (brouillon)',
  'overview.backlog.awaitingSchedule': 'À planifier',

  'overview.bookings.title':           'Aperçu des réservations',
  'overview.bookings.today':           "Aujourd'hui",
  'overview.bookings.week':            'Cette semaine',
  'overview.bookings.month':           'Ce mois',
  'overview.bookings.total':           'Total',
  'overview.bookings.revenueLabel':    "Chiffre d'affaires",

  'overview.demand.title':             'Demande en temps réel',
  'overview.demand.level.low':         'Faible demande',
  'overview.demand.level.normal':      'Demande normale',
  'overview.demand.level.high':        'Forte demande',
  'overview.demand.level.very_high':   'Très forte demande',
  'overview.demand.surge':             'Multiplicateur',
  'overview.demand.pending':           'Demandes en attente',
  'overview.demand.available':         'Chauffeurs disponibles',
  'overview.demand.ratio':             'Ratio demande/offre',
  'overview.demand.assigned':          'Courses assignées',
  'overview.demand.updated':           'Mis à jour:',

  'overview.platform.title':           'Statistiques plateforme',
  'overview.platform.totalUsers':      'Utilisateurs',
  'overview.platform.totalEnterprises':'Entreprises',
  'overview.platform.totalDrivers':    'Chauffeurs totaux',
  'overview.platform.activeDrivers':   'Chauffeurs approuvés',
  'overview.platform.onlineDrivers':   'En ligne',

  'overview.empty':                    'Aucune donnée pour le moment',
  'overview.error':                    'Erreur de chargement',

  // Phase 2.2 — Bookings list
  'bookings.title':                    'Réservations',
  'bookings.search.placeholder':       'Rechercher par référence (ex: BM-...)',
  'bookings.filter.all':               'Tous les statuts',
  'bookings.results.count':            '{n} résultat(s)',
  'bookings.export.csvFull':           'Exporter CSV — liste complète',

  'bookings.col.reference':            'Référence',
  'bookings.col.date':                 'Date',
  'bookings.col.route':                'Trajet',
  'bookings.col.client':               'Client',
  'bookings.col.price':                'Prix',
  // SC-PR-7: new column showing the customer-widget tier (eco / business
  // / van). G3.E: PRIORITY removed. Surfaces the bookings.service_type
  // field persisted since SC-PR-5 / SC-PR-6.
  'bookings.col.tier':                 'Tier',
  'bookings.col.driver':               'Chauffeur',
  'bookings.col.status':               'Statut',
  'bookings.col.actions':              'Actions',

  // SC-PR-7: tier badge labels (currently rendered via TierBadge.toUpperCase
  // on the raw value; kept here for future i18n usage and operator clarity).
  'bookings.tier.eco':                 'ÉCO',
  'bookings.tier.business':            'BUSINESS',
  'bookings.tier.van':                 'VAN',
  // G3.E: 'bookings.tier.priority' removed — PRIORITY no longer a
  // customer-widget tier.
  'bookings.tier.unknown':             '—',

  'bookings.action.open':              'Ouvrir',
  'bookings.action.timeline':          'Chronologie',

  // Booking scheduling transition (awaiting_schedule → confirmed)
  'schedule.action':                   'Planifier',
  'schedule.title':                    'Planifier la réservation',
  'schedule.field.pickup':             'Adresse de départ',
  'schedule.field.destination':        'Adresse d\'arrivée',
  'schedule.field.pickupLat':          'Départ — latitude',
  'schedule.field.pickupLng':          'Départ — longitude',
  'schedule.field.destLat':            'Arrivée — latitude',
  'schedule.field.destLng':            'Arrivée — longitude',
  'schedule.field.date':               'Date',
  'schedule.field.time':               'Heure',
  'schedule.field.passengers':         'Passagers',
  'schedule.field.vehicleClass':       'Classe de véhicule',
  'schedule.missingHint':              'Tous les champs sont requis pour planifier (rendre la réservation prête au dispatch).',
  'schedule.submit':                   'Planifier (Confirmer)',
  'schedule.cancel':                   'Annuler',
  'schedule.ok':                       'Réservation planifiée',
  'schedule.error':                    'Planification impossible',
  // SC-PR-11: new row action — opens the advisory refund-guidance modal.
  // Modal is read-only; it never triggers a refund.
  'bookings.action.refundGuidance':    'Conseil de remboursement (consultatif)',
  'bookings.driver.none':              '—',

  // SC-PR-11 — Refund Guidance modal (advisory-only consumer of
  // GET /admin/bookings/{id}/refund-recommendation).
  'bookings.refundGuidance.title':                      'Conseil de remboursement',
  'bookings.refundGuidance.subtitleAdvisory':           'Avis consultatif — l’opérateur décide',
  'bookings.refundGuidance.bookingRef':                 'Réservation {ref}',
  'bookings.refundGuidance.reason.label':               'Motif d’annulation',
  'bookings.refundGuidance.reason.placeholder':         'Choisir un motif…',
  'bookings.refundGuidance.reason.customer_request':    'Demande du client',
  'bookings.refundGuidance.reason.driver_unavailable':  'Chauffeur indisponible',
  'bookings.refundGuidance.reason.payment_failed':      'Paiement échoué',
  'bookings.refundGuidance.reason.duplicate_booking':   'Réservation en double',
  'bookings.refundGuidance.reason.fraud_suspected':     'Fraude soupçonnée',
  'bookings.refundGuidance.reason.operational':         'Opérationnel',
  'bookings.refundGuidance.reason.no_show':             'Non-présentation',
  'bookings.refundGuidance.reason.other':               'Autre',
  'bookings.refundGuidance.classification.FULL_REFUND':            'Remboursement intégral',
  'bookings.refundGuidance.classification.PARTIAL_REFUND':         'Remboursement partiel',
  'bookings.refundGuidance.classification.NO_REFUND':              'Aucun remboursement',
  'bookings.refundGuidance.classification.NOT_APPLICABLE':         'Non applicable',
  'bookings.refundGuidance.classification.MANUAL_REVIEW_REQUIRED': 'Décision opérateur',
  'bookings.refundGuidance.card.recommendedAmount':     'Montant recommandé',
  'bookings.refundGuidance.card.fee':                   'Frais',
  'bookings.refundGuidance.card.policyVersion':         'Version de la politique',
  'bookings.refundGuidance.card.explanation':           'Explication',
  'bookings.refundGuidance.advisoryBanner.line1':
    'Cette recommandation est issue d’une politique provisoire (« draft / advisory ») en attente de validation juridique.',
  'bookings.refundGuidance.advisoryBanner.line2':
    'Le moteur n’exécute aucun remboursement. L’opérateur décide du montant réellement remboursé via le flux existant.',
  'bookings.refundGuidance.action.close':               'Fermer',
  'bookings.refundGuidance.action.openLegacy':          'Ouvrir le flux légal ↗',
  'bookings.refundGuidance.state.pickReason':           'Choisissez un motif pour obtenir une recommandation.',
  'bookings.refundGuidance.state.loading':              'Calcul en cours…',
  'bookings.refundGuidance.state.error':                'Impossible d’obtenir une recommandation. Utilisez le flux légal avec votre jugement opérationnel.',
  'bookings.refundGuidance.state.unavailable':          'Recommandation non disponible.',

  'bookings.empty.title':              'Aucune réservation',
  'bookings.empty.descNoFilter':       'Aucune réservation pour le moment.',
  'bookings.empty.descFilter':         'Aucune réservation correspondant aux critères.',

  'bookings.error.title':              'Erreur de chargement',
  'bookings.error.retry':              'Réessayer',

  'bookings.page.prev':                'Précédent',
  'bookings.page.next':                'Suivant',
  'bookings.page.current':             'Page {n}',

  'bookings.toast.csv.error':          'Échec du téléchargement CSV',

  // Phase 2.2 — Bookings Timeline modal
  'bookings.timeline.title':           'Chronologie',
  'bookings.timeline.subtitle':        'Événements enregistrés pour la réservation {ref}',
  'bookings.timeline.empty':           'Aucun événement enregistré',
  'bookings.timeline.actor.by':        'par',
  'bookings.timeline.close':           'Fermer',

  // AV3-M1 — V3-native Booking Detail (detail + cancel + reassign).
  // Refund history is shown READ-ONLY via the timeline's REFUND_PROCESSED events;
  // no refund action and no incident creation are exposed in this phase.
  'bookings.detail.back':              'Réservations',
  'bookings.detail.title':             'Réservation {ref}',
  'bookings.detail.created':           'Créée le {date}',
  'bookings.detail.loading':           'Chargement de la réservation…',
  'bookings.detail.readOnly':          'Lecture seule',
  'bookings.detail.section.route':     'Trajet',
  'bookings.detail.section.customer':  'Client',
  'bookings.detail.section.pricing':   'Tarification',
  'bookings.detail.section.driver':    'Chauffeur',
  'bookings.detail.section.payment':   'Paiement',
  'bookings.detail.section.risk':      'Évaluation du risque',
  'bookings.detail.section.incidents': 'Incidents',
  'bookings.detail.section.timeline':  'Chronologie des événements',
  'bookings.detail.field.pickup':        'Départ',
  'bookings.detail.field.destination':   'Destination',
  'bookings.detail.field.date':          'Date',
  'bookings.detail.field.time':          'Heure',
  'bookings.detail.field.passengers':    'Passagers',
  'bookings.detail.field.email':         'E-mail',
  'bookings.detail.field.phone':         'Téléphone',
  'bookings.detail.field.notes':         'Notes',
  'bookings.detail.field.serviceType':   'Type de service',
  'bookings.detail.field.distance':      'Distance',
  'bookings.detail.field.duration':      'Durée',
  'bookings.detail.field.surge':         'Majoration',
  'bookings.detail.field.total':         'Total',
  'bookings.detail.field.name':          'Nom',
  'bookings.detail.field.licensePlate':  'Plaque',
  'bookings.detail.field.status':        'Statut',
  'bookings.detail.field.provider':      'Fournisseur',
  'bookings.detail.field.amount':        'Montant',
  'bookings.detail.field.txnId':         'ID de transaction',
  // FC-R2 T8 (SPEC-8): localized labels for the persisted booking.payment_status
  // (authoritative since FC-R2 — written by the canonical capture unit).
  'bookings.detail.paymentStatus.paid':              'Payé',
  'bookings.detail.paymentStatus.partiallyRefunded': 'Partiellement remboursé',
  'bookings.detail.paymentStatus.refunded':          'Remboursé',
  'bookings.detail.driver.none':         'Aucun chauffeur assigné',
  'bookings.detail.timeline.empty':      'Aucun événement enregistré',
  'bookings.detail.risk.score':          'Score',
  'bookings.detail.risk.signals':        'Signaux',
  'bookings.detail.action.reassign':     'Réattribuer le chauffeur',
  'bookings.detail.action.assign':       'Assigner un chauffeur',
  'bookings.detail.action.cancel':       'Annuler la réservation',
  'bookings.detail.action.refund':        'Rembourser',
  'bookings.detail.action.refundHistory': 'Historique des remboursements',
  'bookings.detail.action.incident':       'Signaler un incident',
  'bookings.detail.action.incidentUpdate': 'Mettre à jour le statut',

  // Cancel modal
  'bookings.cancel.title':             'Annuler la réservation',
  'bookings.cancel.description':       'Annulation de la réservation {ref}. Cette action est définitive.',
  'bookings.cancel.reasonLabel':       'Motif d’annulation',
  'bookings.cancel.reasonPlaceholder': 'Choisir un motif…',
  'bookings.cancel.detailLabel':       'Détail (optionnel)',
  'bookings.cancel.notifyCustomer':    'Notifier le client',
  'bookings.cancel.notifyDriver':      'Notifier le chauffeur',
  'bookings.cancel.reasonRequired':    'Sélectionnez un motif pour continuer.',
  'bookings.cancel.confirm':           'Annuler la réservation',
  'bookings.cancel.cancel':            'Fermer',
  'bookings.cancel.ok':                'Réservation annulée',
  'bookings.cancel.error':             'Échec de l’annulation',

  // Reassign modal
  'bookings.reassign.title':            'Réattribuer le chauffeur',
  'bookings.reassign.description':      'Sélectionnez un nouveau chauffeur pour la réservation {ref}.',
  'bookings.reassign.driverLabel':      'Chauffeur',
  'bookings.reassign.driverPlaceholder':'Choisir un chauffeur…',
  'bookings.reassign.driversLoading':   'Chargement des chauffeurs…',
  'bookings.reassign.noDrivers':        'Aucun chauffeur disponible',
  'bookings.reassign.reasonLabel':      'Motif de réattribution',
  'bookings.reassign.reasonPlaceholder':'Choisir un motif…',
  'bookings.reassign.detailLabel':      'Détail (optionnel)',
  'bookings.reassign.required':         'Sélectionnez un chauffeur et un motif pour continuer.',
  'bookings.reassign.confirm':          'Réattribuer',
  'bookings.reassign.cancel':           'Fermer',
  'bookings.reassign.ok':               'Chauffeur réattribué',
  'bookings.reassign.error':            'Échec de la réattribution',

  // Assign modal (initial assignment of an unassigned booking — same endpoint)
  'bookings.assign.title':              'Assigner un chauffeur',
  'bookings.assign.description':        'Sélectionnez un chauffeur pour la réservation {ref}.',
  'bookings.assign.driverLabel':        'Chauffeur',
  'bookings.assign.driverPlaceholder':  'Choisir un chauffeur…',
  'bookings.assign.driversLoading':     'Chargement des chauffeurs…',
  'bookings.assign.noDrivers':          'Aucun chauffeur assignable',
  'bookings.assign.reasonLabel':        'Motif d’attribution',
  'bookings.assign.reasonPlaceholder':  'Choisir un motif…',
  'bookings.assign.detailLabel':        'Détail (optionnel)',
  'bookings.assign.required':           'Sélectionnez un chauffeur et un motif pour continuer.',
  'bookings.assign.confirm':            'Assigner le chauffeur',
  'bookings.assign.cancel':             'Fermer',
  'bookings.assign.ok':                 'Chauffeur assigné',
  'bookings.assign.error':              'Échec de l’attribution',

  // Refund modal (A-2 — POST /payments/refund, canonical refund authority)
  'bookings.refund.title':             'Rembourser la réservation',
  'bookings.refund.description':       'Remboursement pour la réservation {ref}.',
  'bookings.refund.auditWarning':      'Cette action est définitive et sera enregistrée dans le journal d’audit opérateur.',
  'bookings.refund.modeFull':          'Remboursement total',
  'bookings.refund.modePartial':       'Remboursement partiel',
  'bookings.refund.amountLabel':       'Montant à rembourser (€)',
  'bookings.refund.amountHint':        'Maximum {max} €',
  'bookings.refund.reasonLabel':       'Motif',
  'bookings.refund.reason.customer_request': 'Demande du client',
  'bookings.refund.reason.service_issue':    'Problème de service',
  'bookings.refund.reason.duplicate_charge': 'Double facturation',
  'bookings.refund.reason.other':            'Autre',
  'bookings.refund.required':          'Renseignez un motif et un montant valide pour continuer.',
  'bookings.refund.confirm':           'Confirmer le remboursement',
  'bookings.refund.cancel':            'Fermer',
  'bookings.refund.ok':                'Remboursement effectué',
  'bookings.refund.error':             'Échec du remboursement',

  // Refund history modal (A-2 — GET /payments/refund/history/{id}, read-only)
  'bookings.refundHistory.title':         'Historique des remboursements',
  'bookings.refundHistory.original':      'Montant initial',
  'bookings.refundHistory.totalRefunded': 'Total remboursé',
  'bookings.refundHistory.status':        'Statut',
  'bookings.refundHistory.events':        'Événements',
  'bookings.refundHistory.empty':         'Aucun remboursement enregistré',
  'bookings.refundHistory.loading':       'Chargement…',
  'bookings.refundHistory.close':         'Fermer',

  // Incident create modal (A-4 — POST /admin/control-tower/incidents)
  'bookings.incident.title':           'Signaler un incident',
  'bookings.incident.description':     'Signalement d’un incident pour la réservation {ref}.',
  'bookings.incident.auditWarning':    'Cette action sera enregistrée dans le journal d’audit opérateur.',
  'bookings.incident.typeLabel':       'Type d’incident',
  'bookings.incident.typePlaceholder': 'Choisir un type…',
  'bookings.incident.severityLabel':   'Gravité',
  'bookings.incident.severity.low':      'Faible',
  'bookings.incident.severity.medium':   'Moyenne',
  'bookings.incident.severity.high':     'Élevée',
  'bookings.incident.severity.critical': 'Critique',
  'bookings.incident.descriptionLabel':'Description',
  'bookings.incident.required':        'Renseignez un type et une description pour continuer.',
  'bookings.incident.confirm':         'Signaler l’incident',
  'bookings.incident.cancel':          'Fermer',
  'bookings.incident.ok':              'Incident signalé',
  'bookings.incident.error':           'Échec du signalement',

  // Incident status-update modal (A-4 — PATCH /admin/control-tower/incidents/{id})
  'bookings.incidentUpdate.title':               'Mettre à jour l’incident',
  'bookings.incidentUpdate.current':             'Statut actuel : {status}',
  'bookings.incidentUpdate.newStatusLabel':      'Nouveau statut',
  'bookings.incidentUpdate.newStatusPlaceholder':'Choisir un statut…',
  'bookings.incidentUpdate.noTransitions':       'Aucune transition disponible.',
  'bookings.incidentUpdate.notesLabel':          'Notes de résolution (optionnel)',
  'bookings.incidentUpdate.required':            'Sélectionnez un nouveau statut pour continuer.',
  'bookings.incidentUpdate.confirm':             'Mettre à jour',
  'bookings.incidentUpdate.cancel':              'Fermer',
  'bookings.incidentUpdate.ok':                  'Incident mis à jour',
  'bookings.incidentUpdate.error':               'Échec de la mise à jour',

  // Incident status labels
  'bookings.incidentStatus.open':        'Ouvert',
  'bookings.incidentStatus.in_progress': 'En cours',
  'bookings.incidentStatus.resolved':    'Résolu',

  // Phase 2.2 UX polish — collapsible technical payload
  'bookings.timeline.payload.show':    'Voir détails',
  'bookings.timeline.payload.hide':    'Masquer détails',

  // Phase 2.3 — Drivers list (read-only)
  'drivers.title':                     'Chauffeurs',
  'drivers.search.placeholder':        'Rechercher sur la page (nom, email, téléphone, plaque)',
  'drivers.filter.all':                'Tous les statuts',
  'drivers.results.count':             '{n} résultat(s) sur la page',
  'drivers.export.csvFull':            'Exporter CSV — liste complète',

  'drivers.col.driver':                'Chauffeur',
  'drivers.col.phone':                 'Téléphone',
  'drivers.col.vehicle':               'Véhicule',
  'drivers.col.rating':                'Note',
  'drivers.col.rides':                 'Courses',
  'drivers.col.status':                'Statut',
  'drivers.col.approval':              'Approbation',
  'drivers.col.subscription':          'Abonnement',
  'drivers.col.created':               'Créé le',
  'drivers.col.actions':               'Actions',

  'drivers.action.open':               'Ouvrir',
  'drivers.rating.none':               '—',

  'drivers.empty.title':               'Aucun chauffeur',
  'drivers.empty.descNoFilter':        'Aucun chauffeur enregistré pour le moment.',
  'drivers.empty.descFilter':          'Aucun chauffeur correspondant aux critères.',

  'drivers.error.title':               'Erreur de chargement',
  'drivers.error.retry':               'Réessayer',

  'drivers.page.prev':                 'Précédent',
  'drivers.page.next':                 'Suivant',
  'drivers.page.current':              'Page {n}',

  'drivers.toast.csv.error':           'Échec du téléchargement CSV',

  // P1-B3-3a — operational activation toggle (is_active). Migrated from legacy V1.
  'drivers.activation.activate':       'Activer',
  'drivers.activation.deactivate':     'Désactiver',
  'drivers.activation.activated':      'Chauffeur activé',
  'drivers.activation.deactivated':    'Chauffeur désactivé',
  'drivers.activation.error':          "Échec de la mise à jour de l'activation",

  // P1-B3-3b — Add driver (reuses public POST /driver/register). Migrated from legacy V1.
  'drivers.add.action':                'Ajouter un chauffeur',
  'drivers.add.title':                 'Nouveau chauffeur',
  'drivers.add.pendingNote':           "Le chauffeur sera créé comme candidat et devra être approuvé avant de pouvoir opérer.",
  'drivers.add.field.name':            'Nom complet',
  'drivers.add.field.email':           'Email',
  'drivers.add.field.password':        'Mot de passe',
  'drivers.add.field.phone':           'Téléphone',
  'drivers.add.field.vehicleModel':    'Véhicule',
  'drivers.add.field.licensePlate':    'Plaque',
  'drivers.add.required':              'Nom, email, mot de passe, véhicule et plaque sont requis.',
  'drivers.add.ok.pending':            "Chauffeur créé — en attente d'approbation",
  'drivers.add.error':                 'Échec de la création du chauffeur',
  'drivers.add.cancel':                'Annuler',
  'drivers.add.confirm':               'Créer',

  // Phase 2.4 — Onboarding (Pending Driver Approvals View, read-only)
  // GOVERNANCE: NOT a complete onboarding subsystem. Temporary read-only
  // window into GET /admin/beta/pending-drivers; full onboarding domain
  // (KYC/contracts/training/financial setup) deferred to a post-cutover
  // refactor.
  'onboarding.title':                  'Onboarding',
  'onboarding.search.placeholder':     'Rechercher sur la page (nom, email, téléphone, plaque)',
  'onboarding.results.count':          '{n} résultat(s) sur la page',

  'onboarding.col.candidate':          'Candidat',
  'onboarding.col.phone':              'Téléphone',
  'onboarding.col.vehicle':            'Véhicule',
  'onboarding.col.status':             'Statut',
  'onboarding.col.submitted':          'Soumis le',
  'onboarding.col.actions':            'Actions',

  'onboarding.action.open':            'Ouvrir',

  'onboarding.empty.title':            'Aucun candidat en attente',
  'onboarding.empty.descNoFilter':     'Aucun chauffeur candidat en attente d\'approbation pour le moment.',
  'onboarding.empty.descFilter':       'Aucun candidat correspondant aux critères.',

  'onboarding.error.title':            'Erreur de chargement',
  'onboarding.error.retry':            'Réessayer',

  'onboarding.cap.hint':               'Affichage limité aux 100 plus récents en attente (limite serveur).',

  // P1-B3-6 — read-only Beta status card (AV3-34). Source: GET /admin/beta/status.
  'onboarding.beta.title':             'Statut Beta',
  'onboarding.beta.mode.beta':         'Mode Beta actif',
  'onboarding.beta.mode.production':   'Mode Production',
  'onboarding.beta.maxDrivers':        'Chauffeurs max',
  'onboarding.beta.approved':          'Approuvés',
  'onboarding.beta.pending':           'En attente',
  'onboarding.beta.remaining':         'Places restantes',
  'onboarding.beta.totalDrivers':      'Total chauffeurs',
  'onboarding.beta.totalBookings':     'Total courses',
  'onboarding.beta.completedBookings': 'Courses terminées',
  'onboarding.beta.error':             'Erreur de chargement du statut beta',
  'onboarding.beta.retry':             'Réessayer',

  // Phase 2.5 — Operations / Live (read-only dispatch monitor)
  // GOVERNANCE: NOT a mutation surface. Mirror of legacy LiveControlPanel
  // (AdminControlTower.js:200-664) at 5s polling. Drill-down to legacy
  // /admin/bookings/:id until V3 booking detail exists.
  'operations.live.title':             'Opérations — Live',
  'operations.live.search.placeholder':'Rechercher (référence, ID, téléphone, email)',
  'operations.live.results.count':     '{n} résultat(s)',

  'operations.live.kpi.activeBookings':'Bookings actives',
  'operations.live.kpi.anomalies':     'Anomalies',
  'operations.live.kpi.onlineDrivers': 'Chauffeurs en ligne',
  'operations.live.kpi.pendingPayouts':'Versements en attente',
  'operations.live.kpi.openIncidents': 'Incidents ouverts',

  'operations.live.col.priority':      'Priorité',
  'operations.live.col.reference':     'Référence',
  'operations.live.col.status':        'Statut',
  'operations.live.col.route':         'Trajet',
  'operations.live.col.datetime':      'Date / Heure',
  'operations.live.col.driver':        'Chauffeur',
  'operations.live.col.actions':       'Actions',

  'operations.live.action.open':       'Ouvrir',
  'operations.live.driver.none':       'Non assigné',

  'operations.live.empty.title':       'Aucune course active',
  'operations.live.empty.descNoFilter':'Aucune réservation en cours pour le moment.',
  'operations.live.empty.descFilter':  'Aucune réservation correspondant aux critères.',

  'operations.live.error.title':       'Erreur de chargement',
  'operations.live.error.retry':       'Réessayer',

  // Phase 2.6 — Operations / Audit (read-only operator action log)
  // GOVERNANCE: NOT a mutation surface. Mirror of legacy AuditLogPanel
  // (AdminControlTower.js:968-1068). Operator action log is structurally
  // immutable at the backend — read-only by construction.
  'operations.audit.title':                 'Opérations — Audit',
  'operations.audit.subtitle':              'Journal des actions opérateurs',
  'operations.audit.search.placeholder':    'Filtrer par identifiant opérateur (email)',

  'operations.audit.filter.allActions':     'Toutes les actions',
  'operations.audit.filter.actionLabel':    "Type d'action",
  'operations.audit.filter.operatorLabel':  'Opérateur',
  'operations.audit.filter.precedenceHint': "Lorsqu'un opérateur est spécifié, le filtre d'action est ignoré (limitation backend).",

  'operations.audit.summary.totalActions':  '{n} actions au total',
  'operations.audit.summary.uniqueOps':     '{n} opérateurs uniques',

  'operations.audit.col.timestamp':         'Horodatage',
  'operations.audit.col.operator':          'Opérateur',
  'operations.audit.col.action':            'Action',
  'operations.audit.col.target':            'Cible',
  'operations.audit.col.reason':            'Raison',
  'operations.audit.col.status':            'Statut',
  'operations.audit.col.expand':            ' ',

  'operations.audit.status.success':        'Succès',
  'operations.audit.status.failed':         'Échec',

  'operations.audit.detail.show':           'Voir détails',
  'operations.audit.detail.hide':           'Masquer détails',
  'operations.audit.detail.intervention':   'Intervention liée',
  'operations.audit.detail.ipAddress':      'Adresse IP',
  'operations.audit.detail.userAgent':      'User-Agent',
  'operations.audit.detail.session':        'Session',
  'operations.audit.detail.errorMessage':   "Message d'erreur",
  'operations.audit.detail.beforeState':    'État avant',
  'operations.audit.detail.afterState':     'État après',

  'operations.audit.empty.title':           'Aucune action enregistrée',
  'operations.audit.empty.descNoFilter':    "Aucune action opérateur n'a encore été enregistrée.",
  'operations.audit.empty.descFilter':      'Aucune action correspondant aux critères de filtrage.',

  'operations.audit.error.title':           'Erreur de chargement',
  'operations.audit.error.retry':           'Réessayer',

  'operations.audit.cap.hint':              'Affichage limité aux {n} actions les plus récentes (limite serveur). Affiner le filtre pour voir plus.',

  // Phase 2.7 — Operations / Notifications (read-only delivery log)
  // GOVERNANCE: NOT a mutation surface. Read-only window into the unified
  // notification_logs collection (SMS via Twilio + Email via Resend).
  // No resend mutation (Phase 3+); no broadcast (no backend surface).
  'operations.notifications.title':                'Opérations — Notifications',
  'operations.notifications.search.placeholder':   'Rechercher (destinataire, réservation)',
  'operations.notifications.results.count':        '{n} résultat(s) sur la page',

  'operations.notifications.filter.channel':       'Canal',
  'operations.notifications.filter.channelAll':    'Tous les canaux',
  'operations.notifications.filter.channelSms':    'SMS',
  'operations.notifications.filter.channelEmail':  'Email',
  'operations.notifications.filter.status':        'Statut',
  'operations.notifications.filter.statusAll':     'Tous les statuts',

  'operations.notifications.summary.total':        '{n} notifications',
  'operations.notifications.summary.sent':         '{n} envoyées',
  'operations.notifications.summary.failed':       '{n} échouées',

  'operations.notifications.col.datetime':         'Date / Heure',
  'operations.notifications.col.channel':          'Canal',
  'operations.notifications.col.type':             'Type',
  'operations.notifications.col.recipient':        'Destinataire',
  'operations.notifications.col.booking':          'Réservation',
  'operations.notifications.col.status':           'Statut',
  'operations.notifications.col.expand':           ' ',

  'operations.notifications.detail.show':          'Voir détails',
  'operations.notifications.detail.hide':          'Masquer détails',
  'operations.notifications.detail.provider':      'Fournisseur',
  'operations.notifications.detail.providerId':    'ID fournisseur',
  'operations.notifications.detail.messageType':   'Type de message',
  'operations.notifications.detail.errorMessage':  "Message d'erreur",

  // Resend control (A-5 — POST /admin/control-tower/notifications/resend, F14-gated)
  'operations.notifications.resend.label':          'Renvoyer',
  'operations.notifications.resend.disabledReason': 'Renvoi indisponible — correction backend requise (F14).',
  'operations.notifications.resend.ok':             'Notification renvoyée',
  'operations.notifications.resend.error':          'Échec du renvoi',

  'operations.notifications.empty.title':          'Aucune notification',
  'operations.notifications.empty.descNoFilter':   "Aucune notification n'a encore été envoyée.",
  'operations.notifications.empty.descFilter':     'Aucune notification correspondant aux critères.',

  'operations.notifications.error.title':          'Erreur de chargement',
  'operations.notifications.error.retry':          'Réessayer',

  'operations.notifications.cap.hint':             'Affichage limité aux {n} dernières notifications par canal (limite serveur).',

  // Phase 2.8 — Operations / Health (read-only system health monitor)
  // GOVERNANCE: NOT a mutation surface. Mirror of legacy SystemHealthPanel
  // (AdminControlTower.js:1073-1186) at 60s polling cadence. No restart,
  // queue purge, or force-sync controls (Phase 3+ scope at earliest).
  'operations.health.title':                'Opérations — Santé système',
  'operations.health.updatedAt':            'Mis à jour à {t}',

  'operations.health.services.title':       'Services',
  'operations.health.services.mongodb':     'MongoDB',
  'operations.health.services.redis':       'Redis',
  'operations.health.services.connected':   'Connecté',
  'operations.health.services.disconnected':'Déconnecté',
  'operations.health.services.errorLabel':  'Erreur',

  'operations.health.metrics.title':        'Métriques (24 h)',
  'operations.health.metrics.queue':        "File d'attente",
  'operations.health.metrics.queuePending': 'En attente',
  'operations.health.metrics.queueProcessing':'En traitement',
  'operations.health.metrics.queueFailed':  'Échec',
  'operations.health.metrics.paymentErrors':'Erreurs paiement (24 h)',
  'operations.health.metrics.activeBookings':'Bookings actives',
  'operations.health.metrics.openIncidents':'Incidents ouverts',

  'operations.health.error.title':          'Erreur de chargement',
  'operations.health.error.retry':          'Réessayer',

  // Phase 2.9 — Incidents (read-only operational incident log)
  // GOVERNANCE: NOT a mutation surface. Mirror of legacy IncidentManagementPage
  // (AdminControlTowerV2.js:1262-1535). No acknowledge / resolve / escalate /
  // update mutations (Phase 3+).
  'incidents.title':                   'Incidents',
  'incidents.search.placeholder':      'Rechercher (titre, description)',
  'incidents.results.count':           '{n} résultat(s) sur la page',

  'incidents.filter.statusAll':        'Tous les statuts',
  'incidents.filter.typeAll':          'Tous les types',

  'incidents.stats.total':             'Total',
  'incidents.stats.open':              'Ouverts',
  'incidents.stats.inProgress':        'En cours',
  'incidents.stats.resolved':          'Résolus',

  'incidents.col.detected':            'Détecté',
  'incidents.col.severity':            'Sévérité',
  'incidents.col.type':                'Type',
  'incidents.col.status':              'Statut',
  'incidents.col.title':               'Titre',
  'incidents.col.entity':              'Entité',
  'incidents.col.actions':             'Actions',
  'incidents.col.expand':              ' ',

  'incidents.action.open':             'Ouvrir',

  'incidents.detail.show':             'Voir détails',
  'incidents.detail.hide':             'Masquer détails',
  'incidents.detail.description':      'Description',
  'incidents.detail.rootEvent':        'Événement racine',
  'incidents.detail.eventChain':       "Chaîne d'événements",
  'incidents.detail.context':          'Contexte',
  'incidents.detail.resolutionNotes':  'Notes de résolution',
  'incidents.detail.resolvedBy':       'Résolu par',
  'incidents.detail.resolvedAt':       'Résolu le',
  'incidents.detail.intervention':     'Intervention liée',

  'incidents.empty.title':             'Aucun incident',
  'incidents.empty.descNoFilter':      "Aucun incident enregistré pour le moment.",
  'incidents.empty.descFilter':        'Aucun incident correspondant aux critères.',

  'incidents.error.title':             'Erreur de chargement',
  'incidents.error.retry':             'Réessayer',

  'incidents.cap.hint':                'Affichage limité aux {n} incidents les plus récents (limite serveur). Affiner le filtre pour voir plus.',

  // P1-B3-1 — Contacts / messages (read + status triage). Migrated from legacy V1.
  'contacts.title':                    'Messages reçus',
  'contacts.search.placeholder':       'Rechercher (nom, email, message)',
  'contacts.results.count':            '{n} résultat(s) sur la page',
  'contacts.filter.statusAll':         'Tous les statuts',
  'contacts.status.new':               'Nouveau',
  'contacts.status.read':              'Lu',
  'contacts.status.replied':           'Répondu',
  'contacts.status.archived':          'Archivé',
  'contacts.action.markRead':          'Marquer comme lu',
  'contacts.action.markReplied':       'Marquer comme répondu',
  'contacts.action.archive':           'Archiver',
  'contacts.triage.success':           'Statut du message mis à jour',
  'contacts.triage.error':             'Échec de la mise à jour du statut',
  'contacts.empty.title':              'Aucun message',
  'contacts.empty.descNoFilter':       'Les messages des clients apparaîtront ici.',
  'contacts.empty.descFilter':         'Aucun message ne correspond au filtre.',
  'contacts.error.title':              'Erreur de chargement',
  'contacts.error.retry':              'Réessayer',
  'contacts.cap.hint':                 'Affichage limité aux {n} messages les plus récents (limite serveur). Affiner le filtre pour voir plus.',

  // P1-B3-2 — Unassigned dispatch queue (auto-assign + manual assign). Migrated from legacy V1.
  'dispatch.title':                    'Courses à assigner',
  'dispatch.empty.title':              'Toutes les courses sont assignées',
  'dispatch.autoAssign.button':        'Auto',
  'dispatch.autoAssign.success':       'Chauffeur assigné automatiquement',
  'dispatch.assign.placeholder':       'Assigner à…',
  'dispatch.assign.success':           'Chauffeur assigné',
  'dispatch.error.title':              'Erreur de chargement',
  'dispatch.error.retry':              'Réessayer',
  'dispatch.error.autoAssign':         "Échec de l'assignation automatique",
  'dispatch.error.assign':             "Échec de l'assignation",

  // Phase 2.10 — Financial / Billing / Invoices (read-only)
  // GOVERNANCE: NOT a mutation surface. No generate / issue / payment / void
  // controls (Phase 3+). Reads from GET /admin/billing/invoices.
  'billing.invoices.title':            'Facturation — Factures',
  'billing.invoices.search.placeholder':'Rechercher (numéro de facture)',
  'billing.invoices.partner.placeholder':'Filtrer par identifiant partenaire',
  'billing.invoices.results.count':    '{n} résultat(s) sur la page',

  'billing.invoices.filter.statusAll': 'Tous les statuts',

  'billing.invoices.summary.total':    '{n} factures sur la page',
  'billing.invoices.summary.unpaid':   '{amount} dus',

  'billing.invoices.col.number':       'Numéro',
  'billing.invoices.col.issued':       'Émise le',
  'billing.invoices.col.partner':      'Partenaire',
  'billing.invoices.col.period':       'Période',
  'billing.invoices.col.due':          'Échéance',
  'billing.invoices.col.total':        'Total TTC',
  'billing.invoices.col.due_amount':   'Solde dû',
  'billing.invoices.col.status':       'Statut',
  'billing.invoices.col.actions':      'Actions',
  'billing.invoices.col.expand':       ' ',

  'billing.invoices.action.open':      'Ouvrir',

  'billing.invoices.detail.show':      'Voir détails',
  'billing.invoices.detail.hide':      'Masquer détails',
  'billing.invoices.detail.cycle':     'Clé de cycle',
  'billing.invoices.detail.bookings':  'Réservations facturées',
  'billing.invoices.detail.lineItems': 'Lignes de facture',
  'billing.invoices.detail.partnerAddress':'Adresse partenaire',
  'billing.invoices.detail.partnerVat':'N° TVA partenaire',
  'billing.invoices.detail.notes':     'Notes',
  'billing.invoices.detail.subtotal':  'Sous-total HT',
  'billing.invoices.detail.tax':       'TVA ({rate}%)',
  'billing.invoices.detail.amountPaid':'Montant payé',
  'billing.invoices.detail.paidAt':    'Payée le',

  'billing.invoices.empty.title':      'Aucune facture',
  'billing.invoices.empty.descNoFilter':"Aucune facture n'a encore été émise.",
  'billing.invoices.empty.descFilter': 'Aucune facture correspondant aux critères.',

  'billing.invoices.error.title':      'Erreur de chargement',
  'billing.invoices.error.retry':      'Réessayer',

  'billing.invoices.cap.hint':         'Affichage limité aux {n} factures les plus récentes (limite serveur). Affiner le filtre pour voir plus.',

  // ── Tier 1 fiscal UI: Facture generate / detail + Avoir (Commercial activation) ──
  'billing.invoices.action.generate':  'Générer une facture',
  'billing.generate.hint':             "Crée un brouillon de facture pour un partenaire sur une période. L'émission (numéro légal) est une action séparée sur la fiche facture.",
  'billing.generate.partnerId':        'Identifiant partenaire',
  'billing.generate.serviceType':      'Type de service',
  'billing.generate.serviceType.transport': 'Transport de voyageurs (TVA 10%)',
  'billing.generate.serviceType.standard':  'Mise à disposition chauffeur (TVA 20%)',
  'billing.generate.periodStart':      'Début de période',
  'billing.generate.periodEnd':        'Fin de période',
  'billing.generate.paymentTerms':     'Délai de paiement (jours)',
  'billing.generate.submit':           'Générer (brouillon)',
  'billing.generate.ok':               'Facture générée (brouillon)',
  'billing.generate.error':            'Génération impossible',

  'billing.invoiceDetail.back':            'Retour aux factures',
  'billing.invoiceDetail.loading':         'Chargement…',
  'billing.invoiceDetail.cancel':          'Annuler',
  'billing.invoiceDetail.section.partner': 'Partenaire / Client',
  'billing.invoiceDetail.section.amounts': 'Montants',
  'billing.invoiceDetail.section.payment': 'Paiement',
  'billing.invoiceDetail.section.lineItems':'Lignes de facture',
  'billing.invoiceDetail.field.subtotal':  'Sous-total HT',
  'billing.invoiceDetail.field.tax':       'TVA ({rate}%)',
  'billing.invoiceDetail.field.total':     'Total TTC',
  'billing.invoiceDetail.field.paid':      'Montant payé',
  'billing.invoiceDetail.field.due':       'Solde dû',
  'billing.invoiceDetail.field.issued':    'Émise le',
  'billing.invoiceDetail.field.dueDate':   'Échéance',
  'billing.invoiceDetail.field.period':    'Période',
  'billing.invoiceDetail.field.paymentStatus':'Statut de paiement',
  'billing.invoiceDetail.field.paymentRef':'Référence de paiement',
  'billing.invoiceDetail.field.paidAt':    'Payée le',
  'billing.invoiceDetail.action.pdf':      'Télécharger le PDF',
  'billing.invoiceDetail.action.issue':    'Émettre',
  'billing.invoiceDetail.action.void':     'Annuler la facture',
  'billing.invoiceDetail.action.createAvoir':'Créer un avoir',
  'billing.invoiceDetail.void.reason':     "Motif de l'annulation (min. 5 caractères)",
  'billing.invoiceDetail.void.confirm':    "Confirmer l'annulation",
  'billing.invoiceDetail.issued.ok':       'Facture émise',
  'billing.invoiceDetail.issued.warnEmail':"Facture émise, mais l'email n'a pas pu être envoyé",
  'billing.invoiceDetail.voided.ok':       'Facture annulée',
  'billing.invoiceDetail.pdf.error':       'Téléchargement du PDF impossible',
  'billing.invoiceDetail.action.error':    'Action impossible',

  // ── F1 email delivery (shared Facture/Avoir) ──
  'billing.delivery.section':          'Livraison par email',
  'billing.delivery.sent':            'Email envoyé',
  'billing.delivery.failed':          "Échec de l'envoi",
  'billing.delivery.notSent':         'Email pas encore envoyé',
  'billing.delivery.deliveredAt':     'Envoyé le',
  'billing.delivery.attemptAt':       'Dernière tentative',
  'billing.delivery.error':           'Erreur',
  'billing.delivery.retry':           "Renvoyer l'email",
  'billing.delivery.retry.ok':        'Email renvoyé',
  'billing.delivery.retry.failed':    "Échec de l'envoi de l'email",

  'billing.avoirCreate.type':          "Type d'avoir",
  'billing.avoirCreate.type.full':     'Total',
  'billing.avoirCreate.type.partial':  'Partiel',
  'billing.avoirCreate.amount':        'Montant à créditer (HT)',
  'billing.avoirCreate.reason':        "Motif de l'avoir (min. 3 caractères)",
  'billing.avoirCreate.submit':        "Créer l'avoir",
  'billing.avoirCreate.ok':            'Avoir créé (brouillon)',

  'billing.avoirs.title':              'Facturation — Avoirs',
  'billing.avoirs.summary':            '{n} avoir(s)',
  'billing.avoirs.draftBadge':         'Brouillon',
  'billing.avoirs.col.number':         'Numéro',
  'billing.avoirs.col.invoice':        "Facture d'origine",
  'billing.avoirs.col.partner':        'Partenaire',
  'billing.avoirs.col.reason':         'Motif',
  'billing.avoirs.col.total':          'Total TTC',
  'billing.avoirs.col.status':         'Statut',
  'billing.avoirs.col.actions':        'Actions',
  'billing.avoirs.action.open':        'Ouvrir',
  'billing.avoirs.empty.title':        'Aucun avoir',
  'billing.avoirs.empty.desc':         "Aucun avoir n'a encore été créé.",
  'billing.avoirs.error.title':        'Erreur de chargement',
  'billing.avoirs.error.retry':        'Réessayer',

  'billing.avoirDetail.back':          'Retour aux avoirs',
  'billing.avoirDetail.section.original':"Facture d'origine",
  'billing.avoirDetail.section.amounts':'Montants',
  'billing.avoirDetail.section.lineItems':'Lignes créditées',
  'billing.avoirDetail.field.originalInvoice':"Facture d'origine",
  'billing.avoirDetail.field.type':    'Type',
  'billing.avoirDetail.field.issued':  'Émis le',
  'billing.avoirDetail.field.reason':  'Motif',
  'billing.avoirDetail.field.partner': 'Partenaire / Client',
  'billing.avoirDetail.action.pdf':    'Télécharger le PDF',
  'billing.avoirDetail.action.issue':  "Émettre l'avoir",
  'billing.avoirDetail.issued.ok':     'Avoir émis',
  'billing.avoirDetail.issued.warnEmail':"Avoir émis, mais l'email n'a pas pu être envoyé",

  // ── RU-9: refund / avoir / correction-chain reconciliation (display only) ──
  'billing.refundView.title':          'Remboursement & avoirs',
  'billing.refundView.readOnly':       'Lecture seule',
  'billing.refundView.credited':       'Total avoirs émis',
  'billing.refundView.remaining':      'Reste avoirable',
  'billing.refundView.avoirs':         'Avoirs liés',
  'billing.refundView.ledger':         'Écritures de remboursement',
  'billing.refundView.blockedTitle':   'Cas historique bloqué / incohérent — réconciliation automatique impossible',
  'billing.refundView.state.fully_refunded':     'Facture remboursée',
  'billing.refundView.state.partially_refunded': 'Remboursement partiel',
  'billing.refundView.state.not_refunded':       'Non remboursée',
  'billing.refundView.verdict.reconciled':  'Réconcilié',
  'billing.refundView.verdict.repairable':  'Réparable',
  'billing.refundView.verdict.blocked':     'Bloqué',
  'billing.refundView.verdict.no_refund':   'Aucun remboursement',

  // ── Commercial work-queue controls (F-1: filter / search / pagination) ──
  'queue.filter.label':         'Statut',
  'queue.filter.all':           'Tous les statuts',
  'queue.search.placeholder':   'Rechercher (n° ou client)…',
  'queue.search.label':         'Recherche',
  'queue.page.prev':            'Précédent',
  'queue.page.next':            'Suivant',
  'queue.page.info':            '{shown} sur {total}',
  'queue.empty.filtered':       'Aucun résultat pour ce filtre.',

  // ── Tier 2 commercial UI: Devis (CW-1) ──
  'devis.title':                'Devis',
  'devis.summary':             '{n} devis',
  'devis.draftBadge':          'Brouillon',
  'devis.action.create':       'Créer un devis',
  'devis.action.open':         'Ouvrir',
  'devis.col.number':          'Numéro',
  'devis.col.customer':        'Client',
  'devis.col.total':           'Total TTC',
  'devis.col.version':         'Version',
  'devis.col.status':          'Statut',
  'devis.col.actions':         'Actions',
  'devis.empty.title':         'Aucun devis',
  'devis.empty.desc':          "Aucun devis n'a encore été créé.",
  'devis.error.title':         'Erreur de chargement',
  'devis.error.retry':         'Réessayer',
  'devis.create.hint':         "Crée un devis en brouillon. L'envoi (numéro) est une action séparée sur la fiche.",
  'devis.create.requiredHint': 'Les champs marqués * sont obligatoires.',
  'devis.create.req.customer': 'un nom ou une société',
  'devis.create.req.line':     'au moins une ligne (désignation + montant)',
  'devis.create.disabledReason':'Pour créer le devis, renseignez :',
  'devis.create.customer':     'Client',
  'devis.create.customerName': 'Nom',
  'devis.create.customerCompany':'Société',
  'devis.create.customerEmail':'E-mail',
  'devis.create.customerVat':  'N° TVA',
  'devis.create.customerAddress':'Adresse',
  'devis.create.lineItems':    'Lignes',
  'devis.create.lineDesc':     'Désignation',
  'devis.create.lineAmount':   'Montant HT',
  'devis.create.addLine':      'Ajouter une ligne',
  'devis.create.removeLine':   'Supprimer',
  'devis.create.taxRate':      'TVA (%)',
  'devis.create.validDays':    'Validité (jours)',
  'devis.create.notes':        'Notes',
  'devis.create.submit':       'Créer (brouillon)',
  'devis.create.cancel':       'Annuler',
  'devis.create.ok':           'Devis créé (brouillon)',
  'devis.create.error':        'Création impossible',
  'devis.detail.back':         'Retour aux devis',
  'devis.detail.loading':      'Chargement…',
  'devis.section.customer':    'Client',
  'devis.section.amounts':     'Montants (estimatifs)',
  'devis.section.lineage':     'Filiation',
  'devis.section.lineItems':   'Lignes',
  'devis.field.subtotal':      'Sous-total HT',
  'devis.field.tax':           'TVA ({rate}%)',
  'devis.field.total':         'Total TTC estimé',
  'devis.field.validUntil':    "Valide jusqu'au",
  'devis.field.version':       'Version',
  'devis.field.supersedes':    'Remplace',
  'devis.field.supersededBy':  'Remplacé par',
  'devis.field.convertedToBdc':'Bon de commande',
  'devis.field.convertedToBooking':'Réservation',
  'devis.action.pdf':          'Télécharger le PDF',
  'devis.action.send':         'Envoyer',
  'devis.action.accept':       'Accepter',
  'devis.action.reject':       'Refuser',
  'devis.action.expire':       'Expirer',
  'devis.action.cancel':       'Annuler',
  'devis.action.revise':       'Réviser',
  'devis.action.convert':      'Convertir en réservation',
  'devis.action.createBdc':    'Créer un bon de commande',
  'devis.action.error':        'Action impossible',
  'devis.action.pdfError':     'Téléchargement du PDF impossible',
  'devis.action.sentOk':       'Devis envoyé',
  'devis.action.acceptedOk':   'Devis accepté',
  'devis.action.rejectedOk':   'Devis refusé',
  'devis.action.expiredOk':    'Devis expiré',
  'devis.action.cancelledOk':  'Devis annulé',
  'devis.action.revisedOk':    'Nouvelle révision créée',
  'devis.action.convertedOk':  'Réservation créée {ref}',
  'devis.action.bdcCreatedOk': 'Bon de commande créé',
  'devis.reject.reason':       'Motif du refus',
  'devis.cancel.reason':       "Motif de l'annulation",
  'devis.reason.confirm':      'Confirmer',

  // ── Tier 2 commercial UI: Bon de commande (CW-2) ──
  'bdc.title':                 'Bons de commande',
  'bdc.summary':               '{n} bon(s) de commande',
  'bdc.draftBadge':            'Brouillon',
  'bdc.action.create':         'Créer depuis un devis',
  'bdc.action.open':           'Ouvrir',
  'bdc.col.number':            'Numéro',
  'bdc.col.devis':             "Devis d'origine",
  'bdc.col.customer':          'Client',
  'bdc.col.total':             'Total TTC',
  'bdc.col.status':            'Statut',
  'bdc.col.actions':           'Actions',
  'bdc.empty.title':           'Aucun bon de commande',
  'bdc.empty.desc':            "Aucun bon de commande n'a encore été créé.",
  'bdc.error.title':           'Erreur de chargement',
  'bdc.error.retry':           'Réessayer',
  'bdc.create.hint':           "Crée un bon de commande en brouillon depuis un devis accepté. L'émission (numéro) est une action séparée.",
  'bdc.create.devisId':        'Identifiant du devis (accepté)',
  'bdc.create.poRef':          'Référence commande client (optionnel)',
  'bdc.create.submit':         'Créer (brouillon)',
  'bdc.create.cancel':         'Annuler',
  'bdc.create.ok':             'Bon de commande créé (brouillon)',
  'bdc.create.error':          'Création impossible',
  'bdc.detail.back':           'Retour aux bons de commande',
  'bdc.detail.loading':        'Chargement…',
  'bdc.section.lineage':       'Filiation',
  'bdc.section.customer':      'Client',
  'bdc.section.amounts':       'Montants (estimatifs)',
  'bdc.section.lineItems':     'Lignes',
  'bdc.field.sourceDevis':     "Devis d'origine",
  'bdc.field.devisVersion':    'Version du devis',
  'bdc.field.poRef':           'Réf. commande client',
  'bdc.field.convertedToBooking':'Réservation',
  'bdc.field.subtotal':        'Sous-total HT',
  'bdc.field.tax':             'TVA ({rate}%)',
  'bdc.field.total':           'Total TTC estimé',
  'bdc.field.serviceDate':     'Date de service souhaitée',
  'bdc.action.pdf':            'Télécharger le PDF',
  'bdc.action.issue':          'Émettre',
  'bdc.action.sign':           'Signer',
  'bdc.action.cancel':         'Annuler',
  'bdc.action.convert':        'Convertir en réservation',
  'bdc.action.error':          'Action impossible',
  'bdc.action.pdfError':       'Téléchargement du PDF impossible',
  'bdc.action.issuedOk':       'Bon de commande émis',
  'bdc.action.signedOk':       'Bon de commande signé',
  'bdc.action.cancelledOk':    'Bon de commande annulé',
  'bdc.action.convertedOk':    'Réservation créée {ref}',
  'bdc.cancel.reason':         "Motif de l'annulation",
  'bdc.cancel.confirm':        'Confirmer',

  // Phase 2.11 — Financial / Partners (read-only)
  // GOVERNANCE: NOT a mutation surface. No create/update/suspend/activate/pricing
  // controls (Phase 3+). Reads from GET /admin/partners. The api_key field, if
  // present in the payload, is deliberately omitted from display.
  'partners.title':                    'Partenaires',
  'partners.search.placeholder':       'Rechercher sur la page (nom, email)',
  'partners.results.count':            '{n} résultat(s) sur la page',

  'partners.filter.statusAll':         'Tous les statuts',
  'partners.filter.typeAll':           'Tous les types',

  'partners.col.partner':              'Partenaire',
  'partners.col.type':                 'Type',
  'partners.col.status':               'Statut',
  'partners.col.balance':              'Solde courant',
  'partners.col.creditLimit':          'Limite crédit',
  'partners.col.creditUsage':          'Utilisation',
  'partners.col.phone':                'Téléphone',
  'partners.col.created':              'Créé le',
  'partners.col.actions':              'Actions',
  'partners.col.expand':               ' ',

  'partners.action.open':              'Ouvrir',
  // Partner lifecycle (A-7)
  'partners.action.suspend':           'Suspendre',
  'partners.action.activate':          'Réactiver',
  'partners.status.suspended':         'Partenaire suspendu',
  'partners.status.activated':         'Partenaire réactivé',
  'partners.status.error':             'Échec du changement de statut',

  'partners.detail.show':              'Voir détails',
  'partners.detail.hide':              'Masquer détails',
  'partners.detail.address':           'Adresse',
  'partners.detail.pricingProfile':    'Profil tarifaire',
  'partners.detail.billingProfile':    'Profil de facturation',
  'partners.detail.tenant':            'Tenant',

  'partners.empty.title':              'Aucun partenaire',
  'partners.empty.descNoFilter':       "Aucun partenaire enregistré pour le moment.",
  'partners.empty.descFilter':         'Aucun partenaire correspondant aux critères.',

  'partners.error.title':              'Erreur de chargement',
  'partners.error.retry':              'Réessayer',

  'partners.cap.hint':                 'Affichage limité aux {n} partenaires les plus récents (limite serveur). Affiner le filtre pour voir plus.',

  // Phase 2.12 — Financial / Corporate / Entreprises (read-only)
  // GOVERNANCE: NOT a mutation surface. No create/update/employee mutation
  // controls (Phase 3+). Reads from GET /api/enterprises.
  'corporate.title':                   'Entreprises',
  'corporate.search.placeholder':      'Rechercher sur la page (nom, email, SIRET)',
  'corporate.results.count':           '{n} résultat(s) sur la page',

  'corporate.filter.statusAll':        'Tous les statuts',

  'corporate.col.enterprise':          'Entreprise',
  'corporate.col.contact':             'Contact',
  'corporate.col.siret':               'SIRET',
  'corporate.col.status':              'Statut',
  'corporate.col.paymentTerms':        'Délai paiement',
  'corporate.col.budget':              'Budget mensuel',
  'corporate.col.totalBookings':       'Courses',
  'corporate.col.totalSpent':          'Total dépensé',
  'corporate.col.created':             'Créé le',
  'corporate.col.actions':             'Actions',
  'corporate.col.expand':              ' ',

  'corporate.paymentTerms.days':       '{n} jours',
  'corporate.budget.unlimited':        'Illimité',

  'corporate.action.open':             'Ouvrir',

  // Corporate mutations (A-6)
  'corporate.action.edit':             'Modifier',
  'corporate.action.suspend':          'Suspendre',
  'corporate.action.reactivate':       'Réactiver',
  'corporate.action.employees':        'Employés',

  'corporate.field.name':              'Nom',
  'corporate.field.email':             'E-mail',
  'corporate.field.contactName':       'Contact',
  'corporate.field.phone':             'Téléphone',
  'corporate.field.address':           'Adresse',
  'corporate.field.siret':             'SIRET',
  'corporate.field.paymentTerms':      'Délai de paiement (jours)',
  'corporate.field.maxBudget':         'Budget mensuel max (€)',
  'corporate.field.baseRate':          'Tarif de base (€/km)',
  'corporate.field.discount':          'Remise négociée',
  'corporate.field.billingEmail':      'E-mail de facturation',
  'corporate.field.billingAddress':    'Adresse de facturation',
  'corporate.field.department':        'Département',
  'corporate.field.firstName':         'Prénom',
  'corporate.field.lastName':          'Nom',
  'corporate.field.monthlyBudget':     'Budget mensuel (€)',

  'corporate.create.action':           'Nouveau client corporate',
  'corporate.create.title':            'Créer un client corporate',
  'corporate.create.required':         'Renseignez le nom, un e-mail valide, l’adresse et le contact.',
  'corporate.create.confirm':          'Créer',
  'corporate.create.cancel':           'Fermer',
  'corporate.create.ok':               'Client corporate créé',
  'corporate.create.error':            'Échec de la création',

  'corporate.edit.title':              'Modifier {name}',
  'corporate.edit.required':           'Le nom, l’adresse et le contact sont requis.',
  'corporate.edit.confirm':            'Enregistrer',
  'corporate.edit.cancel':             'Fermer',
  'corporate.edit.ok':                 'Client corporate mis à jour',
  'corporate.edit.error':              'Échec de la mise à jour',

  'corporate.status.suspended':        'Client suspendu',
  'corporate.status.reactivated':      'Client réactivé',
  'corporate.status.error':            'Échec du changement de statut',

  'corporate.employees.title':         'Employés — {name}',
  'corporate.employees.loading':       'Chargement des employés…',
  'corporate.employees.empty':         'Aucun employé.',
  'corporate.employees.addTitle':      'Ajouter un employé',
  'corporate.employees.addConfirm':    'Inviter',
  'corporate.employees.added':         'Employé invité',
  'corporate.employees.addError':      'Échec de l’ajout',
  'corporate.employees.removed':       'Employé supprimé',
  'corporate.employees.removeError':   'Échec de la suppression',
  'corporate.employees.resent':        'Invitation renvoyée',
  'corporate.employees.resendError':   'Échec du renvoi',
  'corporate.employees.done':          'Fermer',

  'corporate.employeeStatus.pending':  'En attente',
  'corporate.employeeStatus.active':   'Actif',
  'corporate.employeeStatus.suspended':'Suspendu',

  'corporate.detail.show':             'Voir détails',
  'corporate.detail.hide':             'Masquer détails',
  'corporate.detail.address':          'Adresse',
  'corporate.detail.billingEmail':     'Email de facturation',
  'corporate.detail.billingAddress':   'Adresse de facturation',
  'corporate.detail.baseRate':         'Tarif de base (€/km)',
  'corporate.detail.negotiatedDiscount':'Remise négociée',

  'corporate.empty.title':             'Aucune entreprise',
  'corporate.empty.descNoFilter':      "Aucun compte entreprise enregistré pour le moment.",
  'corporate.empty.descFilter':        'Aucune entreprise correspondant aux critères.',

  'corporate.error.title':             'Erreur de chargement',
  'corporate.error.retry':             'Réessayer',

  'corporate.cap.hint':                'Affichage limité aux {n} entreprises les plus récentes (limite serveur). Aucun filtre serveur disponible.',

  // Phase 2.13 — Financial / Ledger / Grand livre (read-only)
  // GOVERNANCE: Strictly read-only window into the canonical wallet_ledger
  // collection. No payout/withdrawal/transfer execution surface. No balance
  // mutation. Defensive both-taxonomy rendering (LedgerEntryType legacy +
  // OperationType canonical). External provider IDs (Stripe) deliberately
  // omitted from display.
  'financial.ledger.title':            'Grand livre',
  'financial.ledger.subtitle':         'Toute donnée de solde est dérivée des entrées du grand livre',
  'financial.ledger.search.placeholder':'Rechercher sur la page (raison, réservation)',
  'financial.ledger.driverPlaceholder':'Filtrer par identifiant chauffeur',
  'financial.ledger.results.count':    '{n} résultat(s) sur la page',

  'financial.ledger.filter.typeAll':   'Tous les types',

  'financial.ledger.col.timestamp':    'Date / Heure',
  'financial.ledger.col.type':         'Type',
  'financial.ledger.col.driver':       'Chauffeur',
  'financial.ledger.col.account':      'Compte',
  'financial.ledger.col.amount':       'Montant',
  'financial.ledger.col.reference':    'Référence',
  'financial.ledger.col.expand':       ' ',

  'financial.ledger.account.pending':  'En attente',
  'financial.ledger.account.available':'Disponible',
  'financial.ledger.account.both':     'Les deux',
  'financial.ledger.account.none':     '—',

  'financial.ledger.detail.show':      'Voir détails',
  'financial.ledger.detail.hide':      'Masquer détails',
  'financial.ledger.detail.entryId':   'Identifiant entrée',
  'financial.ledger.detail.tenant':    'Tenant',
  'financial.ledger.detail.reason':    'Raison',
  'financial.ledger.detail.createdBy': 'Créé par',
  'financial.ledger.detail.balances':  'Soldes après entrée (dérivés)',
  'financial.ledger.detail.balancePending':'En attente',
  'financial.ledger.detail.balanceAvailable':'Disponible',
  'financial.ledger.detail.balanceTotal':'Total',
  'financial.ledger.detail.operationId':'Identifiant opération',
  'financial.ledger.detail.cycleId':   'Identifiant cycle',
  'financial.ledger.detail.frozen':    'Entrée gelée',
  'financial.ledger.detail.eligibleAt':'Éligible le',
  'financial.ledger.detail.releasedFrom':'Libère opération',
  'financial.ledger.detail.reversedFrom':'Annule opération',
  'financial.ledger.detail.failedFrom':'Échec de opération',

  'financial.ledger.empty.title':      'Aucune entrée de grand livre',
  'financial.ledger.empty.descNoFilter':"Aucune entrée enregistrée pour le moment.",
  'financial.ledger.empty.descFilter': 'Aucune entrée correspondant aux critères.',

  'financial.ledger.error.title':      'Erreur de chargement',
  'financial.ledger.error.retry':      'Réessayer',

  'financial.ledger.cap.hint':         'Affichage limité aux {n} entrées les plus récentes (limite serveur). Affiner le filtre pour voir plus.',

  // Phase 2.14 — Financial / Withdrawals (read-only)
  // GOVERNANCE: Strictly read-only window into driver_withdrawals collection.
  // No execution surface. Status changes happen via the automated payout
  // engine. Defensive rendering of all 6 WithdrawalStatus enum values.
  'financial.withdrawals.title':               'Retraits',
  'financial.withdrawals.subtitle':            "Visualisation en lecture seule des demandes de versement. Toute exécution se fait via le moteur de paiement automatisé.",
  'financial.withdrawals.search.placeholder':  "Rechercher sur la page (identifiant, chauffeur, clé d'idempotence)",
  'financial.withdrawals.results.count':       '{n} résultat(s) sur la page',

  'financial.withdrawals.filter.statusAll':    'Tous les statuts',

  'financial.withdrawals.summary.pending':     'En attente',
  'financial.withdrawals.summary.processing':  'En cours',
  'financial.withdrawals.summary.completed':   'Versées',
  'financial.withdrawals.summary.failed':      'Échecs',

  'financial.withdrawals.col.datetime':        'Date / Heure',
  'financial.withdrawals.col.status':          'Statut',
  'financial.withdrawals.col.driver':          'Chauffeur',
  'financial.withdrawals.col.amount':          'Montant',
  'financial.withdrawals.col.stripeId':        'Identifiant Stripe',
  'financial.withdrawals.col.reference':       'Référence',
  'financial.withdrawals.col.actions':         'Actions',
  'financial.withdrawals.col.expand':          ' ',

  'financial.withdrawals.action.open':         'Ouvrir',

  'financial.withdrawals.detail.show':         'Voir détails',
  'financial.withdrawals.detail.hide':         'Masquer détails',
  'financial.withdrawals.detail.withdrawalId': 'Identifiant complet',
  'financial.withdrawals.detail.stripeId':     'Identifiant Stripe complet',
  'financial.withdrawals.detail.idempotency':  "Clé d'idempotence",
  'financial.withdrawals.detail.errorMessage': "Détail technique de l'erreur",
  'financial.withdrawals.detail.createdAt':    'Créé le',
  'financial.withdrawals.detail.updatedAt':    'Mis à jour le',
  'financial.withdrawals.detail.tenant':       'Tenant',

  'financial.withdrawals.empty.title':         'Aucune demande de versement',
  'financial.withdrawals.empty.descNoFilter':  "Aucune demande de versement enregistrée pour le moment.",
  'financial.withdrawals.empty.descFilter':    'Aucune demande correspondant aux critères.',

  'financial.withdrawals.error.title':         'Erreur de chargement',
  'financial.withdrawals.error.retry':         'Réessayer',

  'financial.withdrawals.cap.hint':            'Affichage limité aux {n} demandes les plus récentes (limite serveur). Affiner le filtre pour voir plus.',

  // Phase 2.15 — Financial / Payouts (read-only)
  // GOVERNANCE: Per-booking accrual records (the payouts collection).
  // DISTINCT from withdrawals (Phase 2.14) — different domain entities.
  // Source: GET /admin/control-tower/financial/payouts.
  'financial.payouts.title':                'Versements par course',
  'financial.payouts.subtitle':             "Visualisation en lecture seule des versements par course. Distincts des retraits bancaires.",
  'financial.payouts.search.placeholder':   "Rechercher sur la page (identifiant, course, chauffeur)",
  'financial.payouts.driverPlaceholder':    'Filtrer par identifiant chauffeur',
  'financial.payouts.results.count':        '{n} résultat(s) sur la page',

  'financial.payouts.filter.statusAll':     'Tous les statuts',

  'financial.payouts.col.datetime':         'Date / Heure',
  'financial.payouts.col.status':           'Statut',
  'financial.payouts.col.driver':           'Chauffeur',
  'financial.payouts.col.booking':          'Course',
  'financial.payouts.col.amount':           'Montant',
  'financial.payouts.col.stripeId':         'Identifiant Stripe',
  'financial.payouts.col.actions':          'Actions',
  'financial.payouts.col.expand':           ' ',

  'financial.payouts.action.open':          'Ouvrir',

  'financial.payouts.detail.show':          'Voir détails',
  'financial.payouts.detail.hide':          'Masquer détails',
  'financial.payouts.detail.payoutId':      'Identifiant complet',
  'financial.payouts.detail.stripeId':      'Identifiant Stripe complet',
  'financial.payouts.detail.createdAt':     'Créé le',
  'financial.payouts.detail.releasedAt':    'Libéré le',
  'financial.payouts.detail.paidAt':        'Versé le',
  'financial.payouts.detail.triggeredAt':   'Déclenché le',
  'financial.payouts.detail.triggeredBy':   'Déclenché par',
  'financial.payouts.detail.interventionReason':"Raison d'intervention",
  'financial.payouts.detail.failureReason': "Détail technique de l'erreur",
  'financial.payouts.detail.tenant':        'Tenant',

  'financial.payouts.empty.title':          'Aucun versement',
  'financial.payouts.empty.descNoFilter':   "Aucun versement enregistré pour le moment.",
  'financial.payouts.empty.descFilter':     'Aucun versement correspondant aux critères.',

  'financial.payouts.error.title':          'Erreur de chargement',
  'financial.payouts.error.retry':          'Réessayer',

  'financial.payouts.cap.hint':             'Affichage limité aux {n} versements les plus récents (limite serveur). Affiner le filtre pour voir plus.',

  // Phase 2.16 — Financial / Trésorerie parent navigation hub (read-only)
  // GOVERNANCE: Pure navigation surface. Zero HTTP calls, zero data fetching,
  // zero polling. Replaces the prior ModulePlaceholder at /admin-v3/financial.
  'financial.hub.title':                    'Trésorerie',
  'financial.hub.subtitle':                 'Visibilité en lecture seule sur les flux financiers chauffeurs.',

  'financial.hub.cards.ledger.title':       'Grand livre',
  'financial.hub.cards.ledger.desc':        "Source de vérité du grand livre chauffeurs. Visibilité en lecture seule des entrées du portefeuille.",

  'financial.hub.cards.withdrawals.title':  'Retraits',
  'financial.hub.cards.withdrawals.desc':   "Demandes de retrait des chauffeurs vers leur compte bancaire. Visibilité en lecture seule.",

  'financial.hub.cards.payouts.title':      'Versements par course',
  'financial.hub.cards.payouts.desc':       "Versements générés par course terminée. Distincts des retraits bancaires. Visibilité en lecture seule.",

  // Phase 2.18 — Subscriptions dormant placeholder (read-only, static)
  // GOVERNANCE: feature held dormant. Zero HTTP calls. Owner ruling 2026-05-26.
  // See docs/SUBSCRIPTIONS_DORMANT_2026-05-26.md.
  'subscriptions.disabled.title':           'Abonnements',
  'subscriptions.disabled.heading':         'Fonctionnalité désactivée pour le moment',
  'subscriptions.disabled.description':     'Les abonnements chauffeurs ne sont pas utilisés dans le modèle opérationnel actuel.',
  'subscriptions.disabled.noActions':       "Aucune action n'est disponible.",

  // Phase X-2 — Commissions read-only module (Option X2-A)
  // GOVERNANCE: read-only surface on the canonical commission_rates matrix
  // shipped by Phase X-1. No mutation copy here — the UI is read-only.
  // See docs/PHASE_X2_PRE_IMPLEMENTATION_CHECKPOINT_2026-05-28.md.
  'commissions.title':                      'Commissions par classe de service',
  'commissions.subtitle':                   "Taux actifs utilisés par le moteur de paie (lecture seule). Toute modification se fait via l'API d'administration ; un éditeur d'interface arrivera dans une phase ultérieure.",
  'commissions.banner.line1':               'La calculation de paie utilise désormais la matrice par classe (Economy 20 % / Van 25 % / Business 30 %).',
  'commissions.banner.line2':               "Le rapport hérité /admin/commission-report continue d'utiliser un taux unique de 15 % et reste exclu de cette interface en attendant la réconciliation Phase X-3.",
  'commissions.col.class':                  'Classe',
  'commissions.col.rate':                   'Taux',
  'commissions.col.version':                'Version',
  'commissions.col.status':                 'Statut',
  'commissions.col.effective_from':         'Effective depuis',
  'commissions.col.created_by':             'Mise à jour par',
  'commissions.loading':                    'Chargement de la matrice…',
  'commissions.empty.title':                'Aucune commission configurée',
  'commissions.empty.desc':                 "La matrice de commission par classe est vide. Le moteur de paie utilisera la valeur par défaut d'EconomyConfig.",
  'commissions.error.title':                'Erreur de chargement',
  'commissions.access_denied.title':        'Accès restreint',
  'commissions.access_denied.desc':         "Vous n'avez pas la permission ADMIN_COMMISSION_RATES_READ requise pour consulter cette section.",
  'commissions.history.title':              'Historique des modifications',
  'commissions.history.col.created_at':     'Date',
  'commissions.history.empty.title':        "Aucun historique disponible",

  // Phase X2-B G3 — Editable commission UI (CONFIRMER-gated)
  // GOVERNANCE: edit affordance hidden unless user.permissions includes
  // ADMIN_COMMISSION_RATES_UPDATE (X2-B G1 r2 C-r2-1, backed by X2-B-S2).
  // See docs/PHASE_X2B_G2_G3_FRONTEND_PLAN_R2_2026-05-28.md.

  // Inline-row edit affordance
  'commissions.edit.button.modify':         'Modifier',
  'commissions.edit.button.cancel':         'Annuler',
  'commissions.edit.button.openModal':      'Modifier…',
  'commissions.edit.row.editing.pill':      'Modification en cours',
  'commissions.edit.row.input.aria':        'Nouveau taux de commission (%)',
  'commissions.edit.row.validation.min':    'Taux minimum : 0 %',
  'commissions.edit.row.validation.max':    'Taux maximum : 30,0 %',
  'commissions.edit.row.validation.nan':    'Veuillez saisir un nombre',
  'commissions.edit.row.validation.noop':   'Identique au taux actuel — aucune modification',

  // Unresolved-permission soft banner
  'commissions.edit.unresolved.banner':     'Permissions non chargées. Reconnectez-vous pour rafraîchir vos permissions.',

  // Confirmation modal
  'commissions.edit.modal.title':           'Confirmer la modification du taux',
  'commissions.edit.modal.body.class':      'Classe',
  'commissions.edit.modal.body.transition': 'Taux actuel : {old} % → Nouveau taux : {new} %',
  'commissions.edit.modal.body.impact':     "Cette modification s'applique à TOUTES les NOUVELLES réservations à partir de maintenant. Les réservations existantes conservent leur taux d'origine.",
  'commissions.edit.modal.attribution':     'Modification enregistrée sous',
  'commissions.edit.modal.audit.label':     "Notes d'audit (facultatif)",
  'commissions.edit.modal.audit.placeholder': "Contexte de la modification, ex. justification ou ticket",
  'commissions.edit.modal.confirm.label':   'Pour confirmer, tapez exactement CONFIRMER en majuscules.',
  'commissions.edit.modal.confirm.placeholder': 'CONFIRMER',
  'commissions.edit.modal.button.cancel':   'Annuler',
  'commissions.edit.modal.button.confirm':  'Confirmer',
  'commissions.edit.modal.submitting':      'Enregistrement…',

  // Success / no-op / warning copy
  'commissions.edit.toast.success':         'Taux mis à jour : {old} % → {new} % pour {class}. Audit ID : {auditId}',
  'commissions.edit.noop.notice':           'Aucun changement appliqué (taux identique au taux actuel).',
  'commissions.edit.warning.inconsistent':  "Réponse incohérente du serveur ({reason}). Rechargez la page pour vérifier l'état réel.",
  'commissions.edit.warning.previous_not_deactivated': "La ligne précédente n'a pas été désactivée par le serveur. Rechargez la page pour vérifier l'état réel.",

  // Error states (modal-inline)
  'commissions.edit.error.title':           'Erreur',
  'commissions.edit.error.forbidden':       'Permission ADMIN_COMMISSION_RATES_UPDATE requise. Veuillez recharger la page.',
  'commissions.edit.error.validation':      'Taux non valide : {detail}',
  'commissions.edit.error.concurrency':     'Une autre modification est en cours pour cette classe. Veuillez recharger et réessayer.',
  'commissions.edit.error.server':          'Erreur serveur — veuillez réessayer ou contacter le support.',
  'commissions.edit.error.timeout':         'Délai dépassé. Vérifiez votre connexion et réessayez.',
  'commissions.edit.error.network':         'Aucune connexion réseau. Vérifiez votre connexion.',

  // History cross-link to Operations/Audit
  'commissions.history.cross_link':         "Voir tous les changements dans l'Audit Opérateur →",

  // =========================================================================
  // DRIVER COMPLIANCE DOMAIN — Phase 4 G5 UI strings (Plan §2.2 M-F-18)
  // C-M-2: MANDATORY French i18n. 100% coverage of new compliance UI required.
  // =========================================================================

  // Navigation
  'nav.compliance':                              'Conformité',
  'nav.compliance.dashboard':                    'Tableau Conformité',
  'nav.compliance.activity':                     "Journal d'activité",

  // Lifecycle states (drivers.lifecycle_state)
  'compliance.lifecycle.pending_backfill':       'En attente de migration',
  'compliance.lifecycle.candidate':              'Candidat',
  'compliance.lifecycle.documents_submitted':    'Documents soumis',
  'compliance.lifecycle.under_review':           'En examen',
  'compliance.lifecycle.approved':               'Approuvé',
  'compliance.lifecycle.active':                 'Actif',
  'compliance.lifecycle.active_ineligible':      'Actif (inéligible)',
  'compliance.lifecycle.suspended':              'Suspendu',
  'compliance.lifecycle.archived':               'Archivé',

  // Compliance posture states (driver_compliance_profiles.compliance_state)
  'compliance.state.pending_backfill':           'En attente de migration',
  'compliance.state.candidate':                  'Candidat',
  'compliance.state.documents_submitted':        'Documents soumis',
  'compliance.state.under_review':               'En examen',
  'compliance.state.approved':                   'Approuvé',
  'compliance.state.active_ineligible':          'Actif (inéligible)',
  'compliance.state.suspended':                  'Suspendu',
  'compliance.state.archived':                   'Archivé',

  // Document types (8 French VTC documents — identity_document added per
  // ratified compliance-approval remediation)
  'compliance.doctype.permis_de_conduire':       'Permis de conduire',
  'compliance.doctype.carte_grise':              'Carte grise',
  'compliance.doctype.attestation_assurance':    "Attestation d'assurance",
  'compliance.doctype.capacite_professionnelle': 'Capacité professionnelle (VTC)',
  'compliance.doctype.kbis':                     'Extrait Kbis',
  'compliance.doctype.casier_judiciaire':        'Extrait de casier judiciaire',
  'compliance.doctype.justificatif_domicile':    'Justificatif de domicile',
  'compliance.doctype.identity_document':        "Pièce d'identité",

  // Verification statuses
  'compliance.verif.pending':                    'En attente',
  'compliance.verif.verified':                   'Vérifié',
  'compliance.verif.rejected':                   'Rejeté',
  'compliance.verif.expired':                    'Expiré',

  // Severity badges
  'compliance.severity.expiring_soon':           'Expire bientôt',
  'compliance.severity.expired':                 'Expiré',
  'compliance.severity.missing':                 'Manquant',

  // Dashboard
  'compliance.dashboard.title':                  'Tableau de bord — Conformité',
  'compliance.dashboard.profiles_by_state':      'Profils par état de conformité',
  'compliance.dashboard.expiring_30d':           'Documents expirant sous 30 jours',
  'compliance.dashboard.search.label':            'Recherche',
  'compliance.dashboard.search.placeholder':     'Rechercher un chauffeur ou un état…',
  'compliance.dashboard.filter.label':            'Filtrer par état',
  'compliance.dashboard.filter.state':           'Filtrer par état',
  'compliance.dashboard.filter.all':             'Tous les états',
  'compliance.dashboard.table.driver':           'Chauffeur',
  'compliance.dashboard.table.state':            'État',
  'compliance.dashboard.table.eligible':         'Éligible dispatch',
  'compliance.dashboard.table.last_updated':     'Mis à jour',
  'compliance.dashboard.empty.title':            'Aucun profil de conformité',
  'compliance.dashboard.empty.desc':             'Les profils apparaîtront dès le déploiement de la Phase 2.',

  // Activity / audit log
  'compliance.activity.title':                   "Journal d'activité — Conformité",
  'compliance.activity.filter.driver':           'Filtrer par chauffeur',
  'compliance.activity.filter.driver.placeholder': 'Nom, e-mail ou identifiant…',
  'compliance.activity.count.events':            'événements',
  'compliance.activity.table.timestamp':         'Horodatage',
  'compliance.activity.table.driver':            'Chauffeur',
  'compliance.activity.table.event':             'Événement',
  'compliance.activity.table.actor':             'Acteur',
  'compliance.activity.table.transition':        'Transition',
  'compliance.activity.table.reason':            'Motif',
  'compliance.activity.empty.title':             'Aucun événement enregistré',

  // Driver Detail page
  'compliance.driverDetail.title':               'Détail chauffeur',
  'compliance.driverDetail.tab.identity':        'Identité',
  'compliance.driverDetail.tab.documents':       'Documents',
  'compliance.driverDetail.tab.approval':        'Approbation',
  'compliance.driverDetail.tab.suspension':      'Suspension',
  'compliance.driverDetail.tab.history':         'Historique',

  // Identity panel
  'compliance.identity.title':                   'Identité du chauffeur',
  'compliance.identity.field.first_name':        'Prénom',
  'compliance.identity.field.last_name':         'Nom',
  'compliance.identity.field.email':             'Email',
  'compliance.identity.field.phone':             'Téléphone',
  'compliance.identity.field.dob':               'Date de naissance',
  'compliance.identity.field.address':           'Adresse',
  'compliance.identity.field.nationality':       'Nationalité',
  'compliance.identity.field.vehicle_model':     'Véhicule',
  'compliance.identity.field.license_plate':     "Plaque d'immatriculation",
  'compliance.identity.field.lifecycle_state':   'État du cycle de vie',
  'compliance.identity.empty':                   'Non renseigné',

  // Documents panel
  'compliance.documents.title':                  'Documents',
  'compliance.documents.empty.title':            'Aucun document téléversé',
  'compliance.documents.empty.desc':             'Téléversez le premier document avec le bouton ci-dessous.',
  'compliance.documents.action.upload':          'Téléverser un document',
  'compliance.documents.table.type':             'Type',
  'compliance.documents.table.version':          'Version',
  'compliance.documents.table.status':           'Statut',
  'compliance.documents.table.expiry':           'Expiration',
  'compliance.documents.table.uploaded_at':      'Téléversé le',
  'compliance.documents.table.actions':          'Actions',
  'compliance.documents.action.view':            'Voir',
  'compliance.documents.action.verify':          'Vérifier',
  'compliance.documents.action.reject':          'Rejeter',
  'compliance.documents.action.request_renewal': 'Demander renouvellement',

  // G11 — Operational UX (queue + filters + state explainer)
  'compliance.queue.title':                       "File d'attente — Documents à valider",
  'compliance.queue.empty.title':                 "Aucun document en attente",
  'compliance.queue.empty.desc':                  "Tous les documents soumis sont déjà revus.",
  'compliance.queue.table.driver':                'Chauffeur',
  'compliance.queue.table.email':                 'E-mail',
  'compliance.queue.table.type':                  'Type',
  'compliance.queue.table.version':               'Version',
  'compliance.queue.table.uploaded_at':           'Téléversé le',
  'compliance.queue.table.expiry':                'Expiration',
  'compliance.queue.table.actions':               'Actions',
  'compliance.queue.action.open':                 'Ouvrir le chauffeur',
  'compliance.queue.filter.doctype':              'Filtrer par type',
  'compliance.queue.filter.alltypes':             'Tous les types',
  'compliance.queue.count':                       'documents en attente',

  'compliance.filter.status':                     'Filtrer par statut',
  'compliance.filter.allstatuses':                'Tous les statuts',
  'compliance.filter.pending':                    'En attente',
  'compliance.filter.verified':                   'Vérifié',
  'compliance.filter.rejected':                   'Rejeté',
  'compliance.filter.renewal_requested':          'Renouvellement demandé',
  'compliance.filter.expired':                    'Expiré',

  'compliance.sort.label':                        'Trier',
  'compliance.sort.uploaded_desc':                'Plus récents en premier',
  'compliance.sort.uploaded_asc':                 'Plus anciens en premier',
  'compliance.sort.type_asc':                     'Par type (A→Z)',
  'compliance.sort.expiry_asc':                   "Expiration la plus proche",

  // State explainer (G11.F)
  'compliance.statePanel.title':                  'État de conformité',
  'compliance.statePanel.current':                'État actuel',
  'compliance.statePanel.explainer.pending_backfill': 'Profil créé sans documents — en attente du téléversement initial.',
  'compliance.statePanel.explainer.candidate':         'Téléversements démarrés — au moins un document soumis.',
  'compliance.statePanel.explainer.documents_submitted': 'Tous les documents requis ont été soumis — à examiner.',
  'compliance.statePanel.explainer.under_review':       'Documents en cours d\'examen administratif.',
  'compliance.statePanel.explainer.approved':           'Profil approuvé — habilitation administrative obtenue.',
  'compliance.statePanel.explainer.active_ineligible':  'Actif mais inéligible au dispatch — vérifier les documents expirés ou rejetés.',
  'compliance.statePanel.explainer.suspended':          'Profil suspendu administrativement.',
  'compliance.statePanel.explainer.archived':           'Profil archivé — état terminal, non opérationnel.',
  'compliance.statePanel.required.title':         'Documents requis',
  'compliance.statePanel.required.status.present':  'Soumis',
  'compliance.statePanel.required.status.verified': 'Vérifié',
  'compliance.statePanel.required.status.missing':  'Manquant',
  'compliance.statePanel.required.status.rejected': 'Rejeté — à reprendre',
  'compliance.statePanel.required.status.expired':  'Expiré',

  // Dashboard deep-link affordances (G11.E)
  'compliance.dashboard.deeplink.openDrivers':    'Ouvrir les chauffeurs',
  'compliance.dashboard.deeplink.openDriver':     'Ouvrir',

  // G11.2 — Operational Workspace Completion
  'compliance.hero.title':                        'Documents à valider',
  'compliance.hero.count.singular':               'document en attente de votre validation',
  'compliance.hero.count.plural':                 'documents en attente de votre validation',
  'compliance.hero.cta.review':                   'Examiner la file',
  'compliance.hero.empty':                        'Tous les documents soumis ont été examinés.',

  'compliance.queue.action.view':                 'Voir',
  'compliance.queue.section.subtitle':            'Validez chaque document directement depuis ce poste de travail.',

  'compliance.drivers_awaiting.title':            'Chauffeurs à examiner',
  'compliance.drivers_awaiting.empty.title':      'Aucun chauffeur en attente',
  'compliance.drivers_awaiting.empty.desc':       "Aucun chauffeur n'a de documents en attente.",
  'compliance.drivers_awaiting.column.driver':    'Chauffeur',
  'compliance.drivers_awaiting.column.pending':   'Documents en attente',
  'compliance.drivers_awaiting.column.types':     'Types soumis',
  'compliance.drivers_awaiting.column.action':    'Action',
  'compliance.drivers_awaiting.action.open':      'Ouvrir le dossier',

  // Activity Journal — enriched rendering (G11.2)
  'compliance.activity.column.driver':            'Chauffeur',
  'compliance.activity.column.document':          'Document',
  'compliance.activity.column.decision':          'Décision',
  'compliance.activity.column.reason':            'Motif',
  'compliance.activity.event.document_uploaded':    'Téléversé par le chauffeur',
  'compliance.activity.event.document_verified':    "Validé par l'admin",
  'compliance.activity.event.document_rejected':    "Rejeté par l'admin",
  'compliance.activity.event.document_renewal_requested': 'Renouvellement demandé',
  'compliance.activity.event.driver_approved':      'Chauffeur approuvé',
  'compliance.activity.event.driver_rejected':      'Chauffeur rejeté',
  'compliance.activity.event.driver_suspended':     'Chauffeur suspendu',
  'compliance.activity.event.driver_reactivated':   'Chauffeur réactivé',
  'compliance.activity.event.driver_archived':      'Chauffeur archivé',

  // Upload modal
  'compliance.uploadModal.title':                'Téléverser un document',
  'compliance.uploadModal.field.type':           'Type de document',
  'compliance.uploadModal.field.file':           'Fichier (PDF / JPEG / PNG ≤ 20 Mo)',
  'compliance.uploadModal.field.expiry':         "Date d'expiration (optionnelle)",
  'compliance.uploadModal.submit':               'Téléverser',
  'compliance.uploadModal.cancel':               'Annuler',
  'compliance.uploadModal.error.no_file':        'Veuillez sélectionner un fichier.',
  'compliance.uploadModal.error.no_type':        'Veuillez sélectionner un type de document.',
  'compliance.uploadModal.error.mime':           'Type de fichier non autorisé. PDF, JPEG ou PNG uniquement.',
  'compliance.uploadModal.error.size':           'Fichier trop volumineux (max. 20 Mo).',
  'compliance.uploadModal.error.generic':        "Échec du téléversement. Veuillez réessayer.",
  'compliance.uploadModal.success':              'Document téléversé avec succès.',

  // Verification modal
  'compliance.verifyModal.title':                'Vérifier le document',
  'compliance.verifyModal.field.notes':          'Notes (optionnelles)',
  'compliance.verifyModal.submit':               'Marquer comme vérifié',
  'compliance.verifyModal.cancel':               'Annuler',
  'compliance.verifyModal.success':              'Document vérifié.',
  'compliance.verifyModal.error':                'Échec de la vérification.',

  // Reject modal
  'compliance.rejectModal.title':                'Rejeter le document',
  'compliance.rejectModal.field.reason':         'Motif du rejet (obligatoire)',
  'compliance.rejectModal.submit':               'Rejeter',
  'compliance.rejectModal.error.reason':         'Le motif est obligatoire.',
  'compliance.rejectModal.success':              'Document rejeté.',

  // Approval workflow panel
  'compliance.approval.title':                   "Workflow d'approbation",
  'compliance.approval.action.approve':          'Approuver',
  'compliance.approval.action.reject':           'Rejeter',
  'compliance.approval.field.reason':            'Motif',
  'compliance.approval.approved.success':        'Chauffeur approuvé.',
  'compliance.approval.rejected.success':        'Chauffeur rejeté.',

  // Suspension panel
  'compliance.suspension.title':                 'Suspension',
  'compliance.suspension.action.suspend':        'Suspendre',
  'compliance.suspension.action.reactivate':     'Réactiver',
  'compliance.suspension.action.archive':        'Archiver',
  'compliance.suspension.action.force_eligible': "Forcer l'éligibilité dispatch",
  'compliance.suspension.field.reason':          'Motif',
  'compliance.suspension.no_active':             'Aucune suspension active.',
  'compliance.suspension.active.label':          'Suspendu depuis',

  // History panel
  'compliance.history.title':                    'Historique de conformité',
  'compliance.history.empty':                    'Aucun événement.',

  // Common
  'compliance.common.loading':                   'Chargement…',
  'compliance.common.error':                     'Une erreur est survenue.',
  'compliance.common.confirm':                   'Confirmer',
  'compliance.common.cancel':                    'Annuler',
  'compliance.common.close':                     'Fermer',
  'compliance.common.yes':                       'Oui',
  'compliance.common.no':                        'Non',

  // Driver-self-service (DriverDashboard panels — components/DriverDocumentsSelfServicePanel etc.)
  'compliance.self.title':                       'Ma conformité',
  'compliance.self.status.label':                'Statut de conformité',
  'compliance.self.documents.label':             'Mes documents',
  'compliance.self.dispatch_eligible':           'Éligible aux courses',
  'compliance.self.dispatch_blocked':            'Inéligible — voir les motifs',
  'compliance.self.upload_my':                   'Téléverser un document',
};

export default fr;
